<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [message]="message"
  [confirmText]="confirmText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
>
  <div class="not-found-container mb-2">
    <h2 class="not-found-title">Elegir Agencia</h2>
    <p>
      Seleccione una agencia <br /> para continuar.
    </p>
    <select>
    </select>
  </div>
</usb-base-modal>
